import { useSelector } from 'react-redux'
import classes from './MenuItem.module.sass'
import { selectDarkTheme } from '../../../../../store/slices/settingsSlice'
type Props = {
  text: string
  icon: string
  onClick: () => void
  visible: boolean
}

export const MenuItem = ({ text, icon, onClick, visible }: Props) => {
  const darkTheme = useSelector(selectDarkTheme)
  if (visible)
    return (
      <div className={darkTheme ? classes.ContainerDark : classes.Container} onClick={onClick}>
        <div>{text}</div>
        <img src={icon} alt={text} className={classes.Icon} />
      </div>
    )
}
